'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { useCustomerKey } from './useCustomerKey';
import { useOneTrustParams } from './useOneTrustParams';
export const OneTrustV2 = () => {
  const $ = _c(16);
  const {
    customerKey
  } = useCustomerKey();
  let t0;
  if ($[0] !== customerKey) {
    t0 = {
      customerKey
    };
    $[0] = customerKey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    token
  } = useOneTrustParams(t0);
  if (!customerKey || !token) {
    return null;
  }
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== customerKey || $[3] !== token) {
    const payload = {
      dataSubjectParams: {
        id: customerKey,
        isAnonymous: false,
        token
      }
    };
    T0 = Script;
    t3 = "OneTrust-Cross-Domain";
    t4 = "afterInteractive";
    t2 = "window.OneTrust = window.OneTrust || {};";
    t1 = JSON.stringify(payload);
    $[2] = customerKey;
    $[3] = token;
    $[4] = T0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    T0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
  }
  const t5 = t2 + `Object.assign(window.OneTrust, ${t1});`;
  let t6;
  if ($[9] !== t5) {
    t6 = {
      __html: t5
    };
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== T0 || $[12] !== t3 || $[13] !== t4 || $[14] !== t6) {
    t7 = <T0 id={t3} strategy={t4} dangerouslySetInnerHTML={t6} />;
    $[11] = T0;
    $[12] = t3;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};